/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { FsInstrumentation } from './instrumentation';
export type {
  CreateHook,
  EndHook,
  FMember,
  FPMember,
  FsInstrumentationConfig,
  FunctionProperties,
  FunctionPropertyNames,
  FunctionPropertyNamesTwoLevels,
  Member,
} from './types';
